import React, { useState } from 'react';

import RenderIf from 'components/RenderIf';
import { Helmet } from 'react-helmet-async';
import {useTranslation} from "react-i18next";

import CheckTicket from './CheckTicket';
import Table from './Table';


import './result.scss';

export default function MyTickets() {
  const [isLoading, setIsLoading] = useState(true);
  const [allData, setAllData] = useState([]);

  const {t} = useTranslation();

  return (
    <React.Fragment>
      <Helmet>
        <title>{t("RESULTS")} | 1x2</title>
        <meta name="description" content={`${t("RESULTS")} | 1x2`} />
      </Helmet>
      <div className="results">
        <div className="results-top">
          <div className=" p-0 container ">
            <CheckTicket />
          </div>
        </div>
        <div className="results-center">
          <div className="container  results-center__container">
            <div className="results-center__title">
              <span>{t("RESULTS")}</span>
            </div>

            <div className="wrapper-table">
              <Table
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                setAllData={setAllData}
              />
            </div>
          </div>
        </div>
        <RenderIf condition={!isLoading}>
          <div className="results-bottom">
            <div className="results-bottom-table p-0 container ">
              <div className="table-end">
                <h1>{t("CIRCULATION_INFORMATION")}</h1>
                <table>
                  <thead>
                    <tr>
                      <th>{t("GAME_COUNT")}</th>
                      <th>{t("PRIZE")}</th>
                      <th>{t("WINNING_TICKET_COUNT")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{allData?.gameCount}</td>
                      <td>{allData?.winningAmount}</td>
                      <td>{allData?.winTicketCount}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </RenderIf>
      </div>
    </React.Fragment>
  );
}
